module.exports = __webpack_public_path__ + "img/electronic_enabled_selected.d47fcb31.svg";